export function getSubcategoryIdForDownloadType(downloadFileType) {
  if (!downloadFileType) return null;
  const id = {
    AUDIO: process.env.REACT_APP_AUDIO_ID,
    VIDEO: process.env.REACT_APP_VIDEO_ID,
    IMAGE: process.env.REACT_APP_IMAGE_ID,
    DOCUMENT: process.env.REACT_APP_DOCUMENT_ID,
  }[downloadFileType];
  return id != null ? parseInt(id, 10) : null;
}

export function getCategoryLabel(cat) {
  if (!cat) return "";
  const locale = (localStorage.getItem("__extraconomy_locale") || "pt").toLowerCase();
  const byLocale = {
    pt: cat.descriptionPortuguese,
    en: cat.descriptionEnglish,
    it: cat.descriptionItalian,
    es: cat.descriptionSpanish,
  };
  return (
    byLocale[locale] ||
    cat.description ||
    cat.descriptionPortuguese ||
    cat.descriptionEnglish ||
    cat.descriptionItalian ||
    cat.descriptionSpanish ||
    ""
  );
}

export function getCategoriesList(res) {
  if (Array.isArray(res)) return res;
  if (res?.messageCode === 200001 && Array.isArray(res?.result)) return res.result;
  if (res?.result) return Array.isArray(res.result) ? res.result : [];
  return [];
}

export function createLocalId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export function discountToPromotionalPrice(price, discountPercent) {
  if (!price || !discountPercent || discountPercent <= 0) return null;
  return Number((price * (1 - discountPercent / 100)).toFixed(2));
}

export function promotionalPriceToDiscount(price, promotionalPrice) {
  if (!price || !promotionalPrice || promotionalPrice <= 0 || promotionalPrice >= price) return null;
  return Number((((price - promotionalPrice) / price) * 100).toFixed(2));
}

export function cloudinaryPreview(id) {
  if (!id) return null;
  return `https://res.cloudinary.com/dwpu3xryx/image/upload/c_fill,h_600,w_600/${id}`;
}

export function formatFileSize(bytes) {
  if (bytes == null || bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const value = (bytes / Math.pow(k, i)).toLocaleString("pt-EU", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${value} ${sizes[i]}`;
}

export function buildVariationCombinations(attributes) {
  const lists = (attributes || [])
    .map((attr) => ({
      name: attr.name?.trim(),
      values: (attr.values || []).filter((v) => v.value?.trim()),
    }))
    .filter((attr) => attr.name && attr.values.length);
  if (!lists.length) return [];

  const combos = lists.reduce((acc, attr) => {
    if (!acc.length) {
      return attr.values.map((value) => [{ attrName: attr.name, value: value.value.trim() }]);
    }
    return acc.flatMap((combo) =>
      attr.values.map((value) => [...combo, { attrName: attr.name, value: value.value.trim() }]),
    );
  }, []);

  return combos.map((parts) => ({
    key: parts.map((p) => p.value).join(" / "),
    label: parts.map((p) => p.value).join(" / "),
    parts,
    price: null,
    stock: 0,
    imageId: null,
    imageFile: null,
    previewUrl: null,
    variationId: null,
  }));
}

export function mergeCombinations(previous, next) {
  const prevMap = new Map((previous || []).map((item) => [item.key, item]));
  return (next || []).map((item) => {
    const existing = prevMap.get(item.key);
    if (!existing) return item;
    return {
      ...item,
      price: existing.price,
      stock: existing.stock,
      imageId: existing.imageId,
      imageFile: existing.imageFile,
      previewUrl: existing.previewUrl,
      variationId: existing.variationId,
    };
  });
}
